import { cacheKey } from 'appConstants';

class Cache {
  constructor() {
    this.cache = new Map();
  }

  set(key, value) {
    this.cache.set(key, value);
  }

  get(key) {
    return this.cache.get(key);
  }

  removeItems(keys) {
    keys.forEach((key) => this.cache.delete(key));
  }

  /**
   * Preserver `JOB_CHAT_ID` key and value and clear the rest of the cache.
   * jobChatId is needed to restart the session if the chat session ended due to network failures or
   * the user has ended the session.
   */
  clear() {
    const jobChatIdValue = this.cache.get(cacheKey.JOB_CHAT_ID);
    this.cache.clear();
    if (jobChatIdValue) {
      this.cache.set(cacheKey.JOB_CHAT_ID, jobChatIdValue);
    }
  }
}

const cache = new Cache();

export { cache };
